export default function updateKey(fetch, settingKey, settingValue) {
	const body = new FormData();

	body.append('value', settingValue);

	fetch(`/api/v2/userSettings/${settingKey}`, 'POST', body);
}